import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  min-height: 100vh;

  @media (min-width: 768px) {
    padding: 5rem 4rem;
  }
`;

const FadeInContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  animation: ${fadeIn} 0.7s ease-out;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: #0077cc;
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  text-align: left;
  max-width: 600px;
  margin: 0 auto 2rem;
  padding-left: 1rem;

  li {
    font-size: 1rem;
    color: #444;
    margin-bottom: 0.8rem;
  }
`;

const InfoBox = styled.div`
  background-color: #f0faff;
  color: #005fa3;
  padding: 1.5rem;
  border-radius: 8px;
  font-size: 1.05rem;
  margin: 2rem 0;
  text-align: center;
  font-weight: 500;
`;

const CTAButton = styled.a`
  background-color: #0077cc;
  color: white;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  display: inline-block;
  transition: background 0.3s ease;

  &:hover {
    background-color: #005fa3;
  }
`;

const FinalLine = styled.p`
  font-size: 1.1rem;
  color: #444;
  margin-top: 2rem;
  font-style: italic;
`;

const ProgressContainer = styled.div`
  margin: 2rem auto 1rem;
  width: 80%;
  max-width: 400px;
  background: #eee;
  border-radius: 8px;
  overflow: hidden;
`;

const ProgressBar = styled.div<{ progress: number }>`
  height: 8px;
  width: ${({ progress }) => progress}%;
  background-color: #0077cc;
  transition: width 0.3s ease;
`;

const Instruction = styled.p`
  font-size: 1rem;
  color: #444;
  margin-top: 1rem;
  line-height: 1.5;
  text-align: center;
  a {
    color: #0077cc;
    cursor: pointer;
    font-weight: 600;
  }
`;



export default function ViewCadastroSucesso(){
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  
  const [isPaused, setIsPaused] = useState(false);
   const totalDuration = 20000;//8s
  const startTimeRef = useRef<number | null>(null);
  const animationFrameRef = useRef<number | null>(null);

  const animateProgress = (timestamp: number) => {
    if (!startTimeRef.current) startTimeRef.current = timestamp;
    const elapsed = timestamp - startTimeRef.current;

    const percent = Math.min((elapsed / totalDuration) * 100, 100);
    setProgress(percent);

    if (percent < 100 && !isPaused) {
      animationFrameRef.current = requestAnimationFrame(animateProgress);
    } else if (percent >= 100 && !isPaused) {
      abrirModal();
    }
  };

  useEffect(() => {
  const timeout = setTimeout(() => {
    startTimeRef.current = performance.now(); // garante valor
    animationFrameRef.current = requestAnimationFrame(animateProgress);
  }, 500); // 500ms garante tempo de montagem total

  return () => {
    clearTimeout(timeout);
    if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
  };
}, []);



 const abrirModal = () => {
    setIsPaused(true);
    Modal.confirm({
      title: "Vamos para a próxima etapa?",
      content: "Gostaria de continuar agora ou precisa de mais tempo para ler?",
      okText: "✅ Sim, vamos!",
      cancelText: "⏳ Ainda estou lendo",
      onOk() {
        navigate("/queroviajar");
      },
      onCancel() {
        // Reinicia progresso com mais tempo
        startTimeRef.current = null;
        setProgress(0);
        setIsPaused(false);
        animationFrameRef.current = requestAnimationFrame(animateProgress);
      }
    });
  };
 

   
  return (
     <Wrapper>
      <FadeInContent>
         
     
        <Title>🎉 Cadastro recebido com sucesso!</Title>

          <ProgressContainer>
          <ProgressBar progress={progress} />
        </ProgressContainer>

        <Instruction>
          <strong>Mas ainda não acabamos...</strong> <br />
          Após ler as instruções e informações abaixo, gostaria de te fazer uma pergunta que pode ser muito vantajosa para você. <br />Se quiser ir logo, 
           <a onClick={() => navigate("/queroviajar")}> clique aqui</a>, ou aguarde para ser redirecionado.
        </Instruction>

        <Paragraph>
          Sua cota foi registrada na nossa plataforma e entra agora no nosso sistema interno de
          oportunidades.
        </Paragraph>

        <Paragraph>
          A partir de agora, vamos buscar por interessados que estejam procurando um período como o
          seu — seja para alugar ou trocar.
        </Paragraph>

        <List>
          <li>📍 Sua cota pode ser oferecida diretamente a viajantes em busca de datas específicas</li>
          <li>🔁 Ela também pode aparecer para outros proprietários interessados em trocar períodos</li>
          <li>🌐 Em alguns casos, divulgamos em plataformas como Airbnb, Booking, Hoteis.com, Decolar e mais</li>
        </List>

        <InfoBox>
          Fique de olho no seu e-mail e WhatsApp: <br/> 
          entraremos em contato assim que houver um interessado no seu período.
        </InfoBox>

        <Paragraph>
          Se tiver dúvidas ou quiser alterar alguma informação, basta nos chamar!
        </Paragraph>

        <CTAButton href="https://wa.me/message/H7PTB2XYZUDAO1" target="_blank">
          📲 Falar com o suporte no WhatsApp
        </CTAButton>

        <FinalLine>
          Obrigado por confiar na Multicotas. Estamos aqui para te ajudar a aproveitar melhor sua cota.
        </FinalLine>
        <CTAButton onClick={() => navigate("/#formulario")}>
  ➕ Cadastrar nova cota
</CTAButton>

      </FadeInContent>
    </Wrapper>
  );
}
 


